import React, { useState, useEffect } from "react";
import Navbar from "../Navbar";
import {
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  Autocomplete,
  Paper,
  Snackbar,
  Alert as MuiAlert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const { API_CONFIG } = require("../../configuration");

const RoleChange = ({ isDropped }) => {
  const navigate = useNavigate();

  const [employeeList, setEmployeeList] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [stateList, setStateList] = useState([]);

  const [formData, setFormData] = useState({
    emp_id: "",
    roles: [],
    states: [],
  });

  const [roleError, setRoleError] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleSnackbarClose = () => setSnackbarOpen(false);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [empRes, roleRes, stateRes] = await Promise.all([
          axios.get(`${API_CONFIG.APIURL}/role/emp_idname`),
          axios.get(`${API_CONFIG.APIURL}/role/list`),
          axios.get(`${API_CONFIG.APIURL}/dashboard/distinct-states`),
        ]);

        setEmployeeList(empRes.data?.data || []);
        setRoleList(roleRes.data?.data || []);
        const states = [
          "Select All",
          ...(stateRes.data?.data || []).map((s) => s.state),
        ];
        setStateList(states);

        // console.log("setting:", states);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchInitialData();
  }, []);

  //     const fetchEmployeeStates = async () => {
  //     try {
  //         const res = await axios.get(
  //             `${API_CONFIG.APIURL}/dashboard/distinct-states`
  //         );

  //         return res.data?.data || [];
  //     } catch (error) {
  //         console.error("Error fetching states:", error);
  //         return [];
  //     }
  // };

  const handleEmpChange = async (event, newValue) => {
    // console.log("handleEmpChange: ",newValue)
    if (newValue) {
      const assignedIds =
        newValue.role_ids_assigned
          ?.split(",")
          .map((id) => parseInt(id.trim())) || [];

      const roles = roleList.filter((r) => assignedIds.includes(r.role_id));
      // 🔥 fetch states from API
      // const statesData = await fetchEmployeeStates();
      // console.log("Selected Employee:", newValue);
      // console.log("Selected statesData:", statesData);
      //     const assignedStates = [
      //     ...new Set(
      //         newValue
      //             .map((item) => item)
      //             .filter((s) => s && s !== "Select All")
      //     )
      // ];
      const assignedStates = newValue.states
        ? newValue.states.split(",").map((s) => s.trim())
        : [];

      // console.log("assignedStates:", assignedStates);

      setFormData({
        emp_id: newValue.emp_id,
        roles,
        states: assignedStates, // or statesData if you want default all states
      });
    } else {
      setFormData({
        emp_id: "",
        roles: [],
        states: [],
      });
    }
  };

  const handleRoleChange = (event, newValue) => {
    setFormData((prev) => ({ ...prev, roles: newValue }));
    if (newValue.length > 0) setRoleError(false);
  };

  const handleStateChange = (event, newValue) => {
    // console.log("handlestatechange:",newValue)
    if (newValue.includes("Select All")) {
      setFormData((prev) => ({
        ...prev,
        states: stateList.filter((s) => s !== "Select All"),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        states: [...new Set(newValue)],
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.roles.length === 0) {
      setRoleError(true);
      return;
    }

    const requiresStates = formData.roles.some((role) =>
      ["IT-RO_Staff", "IT-RO_USER"].includes(role.role_name),
    );

    if (requiresStates && formData.states.length === 0) {
      setSnackbarMessage(
        "At least one state is required for IT-RO_Staff or IT-RO_USER",
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    const finalFormData = {
      emp_id: formData.emp_id,
      roles: formData.roles.map((r) => r.role_name),
      states_assigned: formData.states.map((s) => s).join(","),
    };
    // console.log('finalFormData: ',finalFormData)

    try {
      const response = await fetch(`${API_CONFIG.APIURL}/role/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(finalFormData),
      });

      if (!response.ok) {
        throw new Error("Failed to update role");
      }

      setSnackbarMessage("User Role Changed Successfully!");
      setSnackbarSeverity("success");
      setFormData({ emp_id: "", roles: [], states: [] });
      setTimeout(() => {
        navigate("/DashBoard");
      }, 3000); // 3 seconds
    } catch (error) {
      console.error("Role update error:", error);
      setSnackbarMessage("User Role Change failed!");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleReset = () => setFormData({ emp_id: "", roles: [], states: [] });

  // const showStates = formData.roles.some((role) =>
  //     ["IT-RO_Staff", "IT-RO_USER"].includes(role.role_name)
  // );
  const showStates =
    formData.states.length >= 0 ||
    formData.roles.some((role) =>
      ["IT-RO_Staff", "IT-RO_USER"].includes(role.role_name),
    );
  // console.log("states data: ",stateList)

  return (
    <>
      <Navbar />
      <Box
  sx={{
    p: { xs: 1.5, sm: 2, md: 3 },
    pt: { xs: "80px", md: "90px" }, // navbar spacing
    ml: { xs: 0, md: "250px" },
    width: {
      xs: "100%",
      md: "calc(100% - 250px)",
    },
    boxSizing: "border-box",
    overflowX: "hidden",
    backgroundColor: "#F9FAFB",
    // minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
  }}
>
        <Paper
          elevation={4}
          sx={{ p: 4, width: "100%", maxWidth: "800px", borderRadius: 3 }}
        >
          <Typography
            variant="h5"
            align="center"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "#0D47A1",
              textTransform: "uppercase",
              borderBottom: "2px solid #0D47A1",
              pb: 1,
            }}
          >
            User Role Change
          </Typography>

          <form onSubmit={handleSubmit}>
            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  options={employeeList}
                  getOptionLabel={(option) =>
                    `${option.emp_id} - ${option.emp_name}`
                  }
                  value={
                    employeeList.find(
                      (emp) => emp.emp_id === formData.emp_id,
                    ) || null
                  }
                  onChange={handleEmpChange}
                  isOptionEqualToValue={(opt, val) => opt.emp_id === val.emp_id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employee ID / Name"
                      required
                      fullWidth
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <Autocomplete
                  multiple
                  options={roleList}
                  getOptionLabel={(option) => option.role_name}
                  value={formData.roles}
                  onChange={handleRoleChange}
                  isOptionEqualToValue={(opt, val) =>
                    opt.role_name === val.role_name
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="User Roles"
                      error={roleError}
                      helperText={
                        roleError ? "Please select at least one role" : ""
                      }
                      fullWidth
                    />
                  )}
                />
              </Grid>

              {/* {showStates && ( */}
              <Grid item xs={12} sm={6}>
                <Autocomplete
                  multiple
                  options={stateList}
                  getOptionLabel={(option) => option}
                  value={formData.states}
                  onChange={handleStateChange}
                  isOptionEqualToValue={(option, value) => option === value}
                  renderInput={(params) => (
                    <TextField {...params} label="States" fullWidth />
                  )}
                />
              </Grid>
              {/* )}  */}
            </Grid>

            <Box
              sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4 }}
            >
              <Button
                variant="outlined"
                color="warning"
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={!formData.emp_id}
              >
                Save
              </Button>
              <Button variant="outlined" color="error" onClick={handleReset}>
                Reset
              </Button>
            </Box>
          </form>
        </Paper>
      </Box>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
          elevation={6}
          variant="filled"
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default RoleChange;
